import { Component, OnInit } from '@angular/core'
import { UserService } from '@service/user/user.service'
import { MobileService } from '@service/mobile.service'
import { environment } from '@environments/environment'
import { SliderImagesService } from '@service/slider-images.service'

@Component({
  selector: 'app-bswals',
  templateUrl: './bswals.component.html',
  styleUrls: ['./bswals.component.scss']
})
export class BswalsComponent implements OnInit {

  public environment = environment

  public hasSliderImages: boolean = false;

  constructor(
    public userService: UserService,
    public MobileService: MobileService,
    public sliderImagesService: SliderImagesService
  ) { }

  ngOnInit(): void {
    this.sliderImagesService.hasSliderImages$.subscribe((hasImages: boolean) => {
      this.hasSliderImages = hasImages;
    })

    this.sliderImagesService.checkHasSliderImages('wiki');
  }
}